// extracted by mini-css-extract-plugin
export var root = "d6lz";
export var rootIcon = "Eapd";
export var rootImage = "WRIa";
export var rootPicture = "jVg-";
export var scaleUpAttention = "b6ao";